import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios";
import i18n from '@/i18n/index'
import '@/utils/rem'

import 'vant/lib/index.css'
import {
  Lazyload, NavBar, Button, Cell, CellGroup, Image as VanImage, Col, Row, Popup, Toast,
  Checkbox, CheckboxGroup, DatetimePicker, Field, Form, ActionSheet,
  Dialog, SwipeCell, ImagePreview, Swipe, SwipeItem, Tab, Tabs, Tag,
  Divider,Loading,DropdownMenu, DropdownItem, Overlay
} from 'vant'

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import '@/assets/global.scss'


import mixin from '@/utils/mixin'

const requireComponent = require.context('./components/dcu', true, /[a-z]\w+\.(vue|js)$/)
// eslint-disable-next-line camelcase
let registerTemplateName_SAVE: any = []
requireComponent.keys().forEach(fileName => {
  // 获取组件配置
  const componentConfig = requireComponent(fileName)
  // const componentName = fileName.toLowerCase().split('/').pop().replace(/\.\w+$/, '')
  const componentName = 'C' + componentConfig.default.uuid.replace(/-/g, '')
  registerTemplateName_SAVE.push(componentName)
  // 全局注册组件
  Vue.component(
    componentName,
    // 如果这个组件选项是通过 `export default` 导出的，
    // 那么就会优先使用 `.default`，
    // 否则回退到使用模块的根。
    componentConfig.default || componentConfig
  )
})

Vue.config.productionTip = false
Vue.mixin(mixin({registerTemplateName_SAVE}))


// import Video from 'video.js'
// import 'video.js/dist/video-js.css'

// Vue.prototype.$video = Video
Vue.prototype.$axios = axios

Vue.use(preview)

Vue.use(Lazyload)
Vue.use(NavBar)
Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(VanImage)
Vue.use(Col)
Vue.use(Row)
Vue.use(Popup)
Vue.use(Toast)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(DatetimePicker)
Vue.use(Field)
Vue.use(Form)
Vue.use(ActionSheet)
Vue.use(Dialog)
Vue.use(SwipeCell)
Vue.use(ImagePreview)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Tag)
Vue.use(Divider)
Vue.use(Loading)
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Overlay);

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
